import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5b691be1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-head-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "cm-align-center cm-ui-ml15",
  style: {"justify-content":"space-between","width":"100%"}
}
const _hoisted_4 = {
  class: "cm-ui-ml5",
  style: {"flex":"1 1 auto"}
}
const _hoisted_5 = {
  class: "gap-x-10 cm-align-center",
  style: {"font-weight":"bold","font-size":"18px","line-height":"normal"}
}
const _hoisted_6 = {
  class: "gap-x-10 cm-ui-mt10 cm-align-center",
  style: {"color":"var(--cm-color-text-secondary)","margin-top":"5px","flex":"1"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cm-ui-ml5" }, "|", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cm-ui-ml5 cm-ui-mr5" }, "|", -1))

import { TerminalIconRound } from '@/views/dashboard/_enum/terminal-icon-round'
import { isolation_status, login_status } from '@/views/dashboard/response-manage/response-handle/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-head',
  props: {
  systemType: {
    type: Number,
    default: 1 | 2
  },
  detailInfo: {
    type: Object,
    default: () => ({})
  },
  loginStatus: {
    type: Number,
    default: 1 | 2 | 4
  },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "logo", {}, () => [
      _createElementVNode("img", {
        class: "terminal-icon",
        src: _unref(TerminalIconRound)[__props.systemType][__props.loginStatus],
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(__props.detailInfo.computer_name) + " ", 1),
            (__props.detailInfo.isolation_status === _unref(isolation_status).separated)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.isolationCellSeparated')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(__props.loginStatus !== 1 ? 'offline' : 'online')
            }, [
              _createTextVNode(_toDisplayString(__props.loginStatus !== _unref(login_status).online ? _ctx.$t('responseHandle.terminalLoginOffline') : _ctx.$t('responseHandle.terminalLoginOnline')) + " ", 1),
              _hoisted_7
            ], 2),
            _createElementVNode("div", null, _toDisplayString(__props.detailInfo.system_name), 1),
            _createTextVNode(),
            _hoisted_8,
            _createElementVNode("div", null, _toDisplayString(__props.detailInfo.user_mark) + "/" + _toDisplayString(__props.detailInfo.group_name), 1)
          ])
        ]),
        _renderSlot(_ctx.$slots, "right-action")
      ])
    ])
  ]))
}
}

})